exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.rounded[data-v-408d2eac] {\n    border-radius: 50px !important;\n}\n", ""]);
